import React, { useState } from "react";
import dayjs from "dayjs";

import { useRecoilValueLoadable, useSetRecoilState } from "recoil";
import { asyncGetOrder, refundDetailState } from "lib/store/billing";
import { modalState } from "lib/store/common";

import "./History.scss";

export type HistoryProps = {
  cx?: string;
};

const usePaymentHistory = (page: number) => {
  const { state, contents } = useRecoilValueLoadable(asyncGetOrder(page));
  let returnVal = {
    count: 0,
    total_pages: 1,
    results: [],
  };
  if (state === "hasValue") {
    returnVal = contents;
  }

  return { state, contents: returnVal };
};
export const History: React.FC<HistoryProps> = ({ cx = "" }) => {
  const setModal = useSetRecoilState(modalState);
  const setRefundDetail = useSetRecoilState(refundDetailState);
  const [currentPage, setCurrentPage] = useState(1);
  const { contents } = usePaymentHistory(currentPage);

  return (
    <div className={`History ${cx}`}>
      <div className="title">Billing History</div>
      <div className="desc">
        위 결제 내역은 VAT가 포함되어 있습니다. 문의사항은
        contact@onmydev.com으로 부탁드립니다.
      </div>
      <ul>
        <li>
          <span>날짜</span>
          <span>결제 금액</span>
          <span>상품</span>
          <span>내역</span>
          <span>영수증</span>
        </li>
        {contents.results
          .filter(({ status }: { status: string }) => status !== "scheduled")
          .map(
            (
              i: {
                id: number;
                merchant_uid: string;
                type: string;
                payment_data: {
                  amount: number;
                  apply_num: string;
                  receipt_url: string;
                  cancel_amount: number;
                  cancel_history: any[];
                };
                status: "paid" | "refunded" | "revoked";
                created_at: string;
              },
              idx: number
            ) => (
              <li key={idx}>
                <span>{dayjs(i.created_at).format("YYYY.MM.DD")}</span>
                {i.status === "refunded" ? (
                  <span>
                    {(
                      i.payment_data.amount - i.payment_data.cancel_amount
                    ).toLocaleString()}
                    원
                  </span>
                ) : (
                  <span className={`bold ${i.status === "revoked"}`}>
                    {i.payment_data.amount.toLocaleString()}원
                  </span>
                )}

                <span>{i.type}</span>

                <span>
                  {i.status === "paid" && "결제 완료"}{" "}
                  {i.status === "revoked" && "구독 취소"}{" "}
                  {i.status === "refunded" && "환불"}
                </span>

                <span className={`underline`}>
                  {i.status === "paid" && (
                    <a href={i.payment_data.receipt_url} target={"_blank"}>
                      결제 영수증
                    </a>
                  )}
                  {i.status === "refunded" && (
                    <span
                      onClick={async () => {
                        await setRefundDetail({
                          uid: i.merchant_uid,
                          order: i.id,
                          receipt: i.payment_data.receipt_url,
                          refundReceipt:
                            i.payment_data.cancel_history[0].receipt_url,
                          type: i.type,
                        });
                        await setModal((_) => ({ ..._, refundDetail: true }));
                      }}
                    >
                      환불 내역서
                    </span>
                  )}
                </span>
              </li>
            )
          )}
      </ul>
      <div className="number-wrapper">
        {Array(contents.total_pages)
          .fill(0)
          .map((i, idx) => (
            <span
              className={idx + 1 === currentPage ? "active" : ""}
              onClick={() => setCurrentPage(idx + 1)}
              key={idx + 1 + "num"}
            >
              {idx + 1}
            </span>
          ))}
      </div>
    </div>
  );
};
